// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap-3EsuvXnE clearfix","box":"box-2tzJMMdL"};